import React from 'react';
import { routes } from 'appConstants';
import { _t } from 'utils';
import { ButtonV4 } from 'components';

import globe from 'assets/img/main-v4/globe.png';
import heroCurve from 'assets/img/main-v4/hero-curve.png';

import styles from './styles.module.scss';

const STATS = [
  {
    id: 'years',
    value: '10 лет',
    label: 'на рынке',
    cta: 'Подробнее о нас',
    to: routes.about.root,
    tone: 'primary' as const,
  },
  {
    id: 'verify',
    value: '3000+',
    label: 'Верификаций зарубежных контрагентов',
    cta: 'Экспортерам',
    to: routes.resolutions.root,
    tone: 'primary' as const,
  },
  {
    id: 'events',
    value: 'В более 100 стран',
    label: 'поставляется Московская продукция',
    cta: null,
    to: null,
    tone: 'accent' as const,
  },
];

const MainPreview = () => (
  <section className={styles.wrap}>
    <div className={styles.curve} aria-hidden>
      <img src={heroCurve} alt="" />
    </div>

    <div className={styles.inner}>
      <div className={styles.copy}>
        <div className={styles.copyText}>
          <h1 className={styles.title}>
            {_t('ЗДЕСЬ ПРОИЗВОДЯТ БУДУЩЕЕ')}
          </h1>
          <p className={styles.subTitle}>
            {_t('Поддержка экспорта, продвижение промышленного и инвестиционного потенциала столицы')}
          </p>
        </div>
        <ButtonV4
          to={routes.resolutions.root}
          label="Получить меры поддержки"
          variant="solid"
          tone="primary"
          className={styles.heroCta}
        />
      </div>

      <div className={styles.visual} aria-hidden>
        <div className={styles.globeSpin}>
          <img src={globe} alt="" className={styles.globe} />
        </div>
      </div>

      <ul className={styles.stats}>
        {STATS.map((item) => {
          const featured = item.tone === 'accent';
          const withCta = Boolean(item.cta && item.to);

          return (
            <li
              key={item.id}
              className={`${styles.stat} ${featured ? styles.statAccent : ''}`}
            >
              {withCta ? (
                <>
                  <div className={styles.statText}>
                    <div className={styles.statValue}>{_t(item.value)}</div>
                    <div className={styles.statLabel}>{_t(item.label)}</div>
                  </div>
                  <ButtonV4
                    to={item.to as string}
                    label={item.cta as string}
                    variant="outline"
                    tone="onDark"
                    radius="sm"
                    className={styles.statCta}
                  />
                </>
              ) : (
                <>
                  <div className={styles.statValue}>{_t(item.value)}</div>
                  <div className={styles.statLabel}>{_t(item.label)}</div>
                </>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  </section>
);

export default MainPreview;
